import { render, staticRenderFns } from "./PendenciesTable.vue?vue&type=template&id=281cefba&"
import script from "./PendenciesTable.vue?vue&type=script&lang=js&"
export * from "./PendenciesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports